import { render, staticRenderFns } from "./ProviderNotLinked.vue?vue&type=template&id=a45845b8&"
import script from "./ProviderNotLinked.vue?vue&type=script&lang=js&"
export * from "./ProviderNotLinked.vue?vue&type=script&lang=js&"
import style0 from "./ProviderNotLinked.vue?vue&type=style&index=0&id=a45845b8&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports